export const localStorageDictionary: Record<string, string> = {
    accessToken: 'accessToken',
};
